import { CompetitionsMenuSchema } from '@/views/sports/components/CompetitionsMenu/styles/CompetitionsMenu.styles';

export const competitionsMenuStyles: CompetitionsMenuSchema = {
  accordion: {
    color: 'alpha.800',
    minW: '190px',
    mr: '3',
    height: 'fit-content',
    boxShadow:
      '0px 3px 5px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
    borderRadius: 'md',
    overflow: 'hidden',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
  },
  accordionButton: {
    pl: '3',
    pr: '2',
    color: 'alpha.600',
    bgGradient: 'linear(to-b, zeta.400, zeta.500)',

    mb: '1px',
    _hover: { bgGradient: 'linear(to-b, zeta.400, zeta.500)' },
  },
  accordionHeadingText: {
    flex: '1',
    fontSize: 'sm',
    textAlign: 'left',
    fontWeight: 'bold',
  },
  accordionIcon: {
    color: 'alpha.700',
  },
  accordionPanel: {
    p: '0',
    fontSize: 'xs',
    color: 'alpha.800',
    fontWeight: 'medium',
    bg: 'transparent',

    _last: {
      border: 'none',
    },
  },
};
